import { LINK_STATE } from '../constants/invitationStates.js';

/** What the accept flow must do next. */
export const ACCEPTANCE_STEP = Object.freeze({
  /** Just render the screen for the link. */
  SHOW: 'show',
  /** The session is still resolving: do nothing yet. */
  WAIT: 'wait',
  /** The recipient confirmed but is not signed in: authenticate first. */
  SIGN_IN: 'signIn',
  /** Confirmed and authenticated: accept now. */
  ACCEPT: 'accept',
});

/**
 * The login-before-accept rule in one place: an invitation is accepted only after the
 * recipient confirmed it AND is authenticated. Being invited, or holding credentials, never
 * grants access on its own.
 *
 * @param {object} state
 * @param {string|null} state.linkState One of `LINK_STATE`.
 * @param {boolean} state.confirmRequested The recipient pressed confirm (or came back from sign-in with intent kept).
 * @param {boolean} state.authLoading The session is still being resolved.
 * @param {boolean} state.isAuthenticated
 */
export const getAcceptanceStep = ({ linkState, confirmRequested, authLoading, isAuthenticated }) => {
  if (linkState !== LINK_STATE.VALID || !confirmRequested) return ACCEPTANCE_STEP.SHOW;
  if (authLoading) return ACCEPTANCE_STEP.WAIT;
  return isAuthenticated ? ACCEPTANCE_STEP.ACCEPT : ACCEPTANCE_STEP.SIGN_IN;
};
